import { useState } from "react";

import { Link } from "react-router-dom";
import {
  LogOut,
  Flag,
  User,
  Megaphone,
  Building2,
  PanelLeftClose,
  PanelLeftOpen,
  Receipt,
  HandCoins,
  Handshake,
  ScrollText,
  House,
  Calculator,
  CheckCircle,
  FolderClosed,
} from "lucide-react";
import {
  Navbar,
  Nav,
  NavItem,
  Button,
  NavbarText,
  NavbarToggler,
  UncontrolledTooltip,
} from "reactstrap";

import { NavLink } from "@/components/NavLink";
import {
  safeLocalStorageGet,
  safeLocalStorageSave,
} from "@/helpers/storageUtils";
import ProtectedRender from "components/ProtectedRender";

// import { NavLink as RRNavLink } from "react-router-dom";

import "./globalSidebar.scss";

const SIDEBAR_STATE_KEY = "global_sidebar_nav_expanded";

const GlobalSidebar = (props) => {
  // Initialize from localStorage with default of true if not found
  const [isExpanded, setIsExpanded] = useState(() =>
    safeLocalStorageGet(SIDEBAR_STATE_KEY, true)
  );

  const toggleSidebar = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    safeLocalStorageSave(SIDEBAR_STATE_KEY, newState);
  };

  return (
    <header
      className={`global-sidebar border-end ${isExpanded ? "expanded" : "collapsed"}`}
      {...props}
    >
      <Navbar>
        <Nav vertical navbar pills>
          <NavItem>
            <NavbarToggler onClick={toggleSidebar} className="p-1">
              {isExpanded ? (
                <PanelLeftClose size={"1.2rem"} />
              ) : (
                <PanelLeftOpen size={"1.2rem"} />
              )}
            </NavbarToggler>
          </NavItem>
          <ProtectedRender requiredPermissions={["dashboard"]}>
            <NavItem id="dashboard-nav">
              <NavLink to="/dashboard">
                <House size={"1.2rem"} className="navbar-icon" />
                <NavbarText>Dashboard</NavbarText>
              </NavLink>
              {!isExpanded && (
                <UncontrolledTooltip placement="right" target="dashboard-nav">
                  Dashboard
                </UncontrolledTooltip>
              )}
            </NavItem>
          </ProtectedRender>

          <NavItem id="brands-nav">
            <NavLink to="/brands">
              <Building2 size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Brands</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="brands-nav">
                Brands
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="campaigns-nav">
            <NavLink to="/campaigns">
              <Megaphone size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Campaigns</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="campaigns-nav">
                Campaigns
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="creators-nav">
            <NavLink to="/creators">
              <User size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Creators</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="creators-nav">
                Creators
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="assignments-nav">
            <NavLink to="/assignments">
              <Handshake size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Assignments</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="assignments-nav">
                Assignments
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="milestones-nav">
            <NavLink to="/milestones">
              <Flag size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Milestones</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="milestones-nav">
                Milestones
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="transfers-nav">
            <NavLink to="/transfers">
              <HandCoins size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Transfers</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="transfers-nav">
                Transfers
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="invoices-nav">
            <NavLink to="/invoices">
              <Receipt size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Invoices</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="invoices-nav">
                Invoices
              </UncontrolledTooltip>
            )}
          </NavItem>

          <NavItem id="agreements-nav">
            <NavLink to="/agreements">
              <ScrollText size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Agreements</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="agreements-nav">
                Agreements
              </UncontrolledTooltip>
            )}
          </NavItem>
          <NavItem id="documents-nav">
            <NavLink to="/documents">
              <FolderClosed size={"1.2rem"} className="navbar-icon" />
              <NavbarText>Documents</NavbarText>
            </NavLink>
            {!isExpanded && (
              <UncontrolledTooltip placement="right" target="documents-nav">
                Documents
              </UncontrolledTooltip>
            )}
          </NavItem>
          <ProtectedRender requiredPermissions={["payment_dashboard"]}>
            <NavItem id="accounting-nav">
              <NavLink to="/accounting">
                <Calculator size={"1.2rem"} className="navbar-icon" />
                <NavbarText>Accounting</NavbarText>
              </NavLink>
              {!isExpanded && (
                <UncontrolledTooltip placement="right" target="accounting-nav">
                  Accounting
                </UncontrolledTooltip>
              )}
            </NavItem>
          </ProtectedRender>
          <ProtectedRender requiredPermissions={["approval_dashboard"]}>
            <NavItem id="approvals-nav">
              <NavLink to="/approvals">
                <CheckCircle size={"1.2rem"} className="navbar-icon" />
                <NavbarText>Approvals</NavbarText>
              </NavLink>
              {!isExpanded && (
                <UncontrolledTooltip placement="right" target="approvals-nav">
                  Approvals
                </UncontrolledTooltip>
              )}
            </NavItem>
          </ProtectedRender>
        </Nav>

        <div className="sidebar-footer">
          <Button
            color="danger"
            outline
            tag={Link}
            to={"/logout"}
            className={`logout-btn ${!isExpanded ? "visually-hidden" : ""}`}
          >
            <LogOut size={"1.2rem"} />
            Logout
          </Button>
        </div>
      </Navbar>
    </header>
  );
};

export default GlobalSidebar;
